import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
  width: 350,
};
function PaymentWarningModal({ open, setOpen, data, setData, Type, }) {
  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            backgroundColor: "white",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          {Type === "Sales" || Type === "DebitNote" ? (
            <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
              <span>
                Do you want to delete the corresponding Receipt Voucher{" "}
                <span style={{ color: "red" }}>
                  "{data.transactionVoucher}"
                </span>{" "}
                also?
              </span>
            </Typography>
          ) : (
            <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
              <span>
                Do you want to delete the corresponding Payment Voucher{" "}
                <span style={{ color: "red" }}>
                  "{data.transactionVoucher}"
                </span>{" "}
                also?
              </span>
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            disabled={loading}
            onClick={() => {
              setData((prev) => ({
                ...prev,
                paymentDeletionFlag: false,
              }));
              setOpen(false);
            }}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => {
              setData((prev) => ({
                ...prev,
                paymentDeletionFlag: true,
              }));
              setOpen(false);
            }}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
}

export default PaymentWarningModal;
